import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ContactForm from '../components/ContactForm'

export default function Home() {
  const [pageData, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Set metadata
    document.title = "Frejlev Auto v/ Jacob Kvist"
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', "Frejlev Auto v/ Jacob Kvist i Aalborg SV hjælper kunder med autoservice og gør det nemt at komme i gang med virksomhedens app.")
    }

    // Fetch page content from CMS
    fetch('https://api.dev.auxo.dk/public/by-slug/da/index')
      .then(res => res.json())
      .then(data => {
        setPage(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching home page:', err)
        setLoading(false)
      })
  }, [])

  const services = [
    {
      num: '01',
      title: 'Autoværksted',
      desc: 'Trænger din bil til at komme på autoværksted eller få et eftersyn? Så kan vi hjælpe. Vi kan tilbyde flere forskellige typer for service til en god pris.',
      link: '/autovaerksted'
    },
    {
      num: '02',
      title: 'Dækskifte',
      desc: 'Står du og skal have skiftet sommerdæk om til vinterdæk eller omvendt? Eller skal du have skiftet dit hjul og vil du slippe for besværet?',
      link: '/daek-og-hjulskift'
    },
    {
      num: '03',
      title: 'Klargøring til syn',
      desc: 'Vi kan stå for klargøringen af din bil, uanset om du står og skal sælge den, eller om det blot er fordi du elsker en ren og gennemgået bil.',
      link: '/klargoering-til-syn'
    },
    {
      num: '04',
      title: 'Mekaniker',
      desc: 'Vi er din lokale mekaniker med over 30 års erfaring. Vi fejlfinder og udbedrer alle problemer professionelt på alle mærker.',
      link: '/mekaniker'
    },
    {
      num: '05',
      title: 'Reparationer',
      desc: 'Skulle uheldet være ude, så kan du med tryghed henvende dig til os. Vi har mange års erfaring og værktøjet til at reparere samtlige bilmærker.',
      link: '/reparationer'
    },
    {
      num: '06',
      title: 'Service',
      desc: 'Det er vigtigt at få din bil til serviceeftersyn. Hvis der er fabriksgaranti på din bil, følger vi altid producentens krav, så garantien bevares.',
      link: '/serviceeftersyn'
    }
  ]

  const mosaicImages = [
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00004_1.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00002_4.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00008_1.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00016.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00007_1.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00017.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00013.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00012.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00020.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00014.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00015.webp',
    'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00019.webp'
  ]

  return (
    <div className="flex flex-col bg-white">
      {/* 1. Hero Section */}
      <section className="relative min-h-[75vh] sm:min-h-[82vh] flex items-center justify-center text-white overflow-hidden py-16 sm:py-24">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/image00002_5.webp"
            alt="Frejlev Auto Facade"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/35"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl space-y-6">
            <p className="text-[#5cbe4f] text-base sm:text-lg font-semibold tracking-wide">
              30 års erfaring indenfor autobranchen
            </p>
            
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-extrabold uppercase tracking-tight leading-tight text-white">
              FREJLEV AUTO - DIT LOKALE AUTOVÆRKSTED I FREJLEV
            </h1>

            <p className="text-gray-200 text-base sm:text-lg leading-relaxed">
              Ved Frejlev Auto udføres service, fejlfinding, reparationer på <strong className="text-white font-bold">alle</strong> bilmærker, uanset alder og mærke.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-2">
              <Link
                to="/frejlev-auto-dit-lokale-autovaerksted"
                className="border-2 border-white hover:bg-white hover:text-gray-900 text-white font-bold text-sm px-7 py-3.5 transition-all flex items-center justify-center gap-2 uppercase tracking-wider"
              >
                <span>LÆS MERE</span>
              </Link>
              <Link
                to="/kontakt-frejlev-auto"
                className="bg-[#5cbe4f] hover:bg-[#4ca83e] text-white font-bold text-sm px-7 py-3.5 transition-all flex items-center justify-center gap-2 shadow-lg shadow-[#5cbe4f]/25 uppercase tracking-wider"
              >
                <span>KONTAKT OS</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Light & Welcoming Intro Section (White Background) */}
      <section className="bg-white py-16 sm:py-24 text-center border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black uppercase tracking-tight text-gray-950">
            FREJLEV AUTO - DIT LOKALE AUTOVÆRKSTED I FREJLEV OG OMEGN
          </h2>
          <div className="w-16 h-1 bg-[#5cbe4f] mx-auto rounded-full"></div>
          <p className="text-gray-600 text-base sm:text-xl leading-relaxed max-w-3xl mx-auto">
            Ved Frejlev Auto udføres service, fejlfinding, reparationer på alle bilmærker, uanset alder og mærke også på el & hybrid.
          </p>
        </div>
      </section>

      {/* 3. Numbered Services Grid */}
      <section className="bg-gray-50 py-20 border-b border-gray-200 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-gray-950 mb-3">
              VORES YDELSER
            </h2>
            <div className="w-12 h-1 bg-[#5cbe4f] mx-auto mb-4"></div>
            <p className="text-gray-600 text-sm sm:text-base">
              Professionelt autoværksted med speciale i alle bilmærker samt moderne el- og hybridbiler.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((item) => (
              <div 
                key={item.num}
                className="relative bg-white border border-gray-200 rounded-xl p-8 flex flex-col justify-between group hover:border-[#5cbe4f] hover:shadow-lg transition-all duration-300"
              >
                {/* Watermark Number */}
                <div className="absolute top-4 right-6 text-6xl sm:text-7xl font-black text-gray-100 select-none pointer-events-none group-hover:text-[#5cbe4f]/15 transition-colors">
                  {item.num}
                </div>

                <div className="relative z-10 space-y-3 mb-6">
                  <span className="text-xs font-bold text-[#5cbe4f] uppercase tracking-wider">{item.num}</span>
                  <h3 className="text-xl font-bold uppercase tracking-tight text-gray-950 group-hover:text-[#5cbe4f] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>

                <div className="relative z-10 pt-4 border-t border-gray-100">
                  <Link
                    to={item.link}
                    className="inline-block border border-gray-900 hover:border-[#5cbe4f] hover:bg-[#5cbe4f] hover:text-white text-gray-900 text-xs font-bold px-4 py-2 uppercase tracking-wider transition-all rounded"
                  >
                    LÆS MERE
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. Experience & About Section (Light / White Background) */}
      <section className="bg-white py-16 sm:py-24 text-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Content */}
            <div className="lg:col-span-7 space-y-6">
              <div className="space-y-3">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase tracking-tight text-gray-950">
                  30 ÅRS ERFARING INDENFOR AUTOBRANCHEN
                </h2>
                <div className="w-16 h-1 bg-[#5cbe4f]"></div>
              </div>

              <div className="text-gray-600 space-y-4 text-sm sm:text-base leading-relaxed">
                <p>
                  Ved Frejlev Auto udføres service, fejlfinding, reparationer på alle bilmærker, uanset alder og mærke også på el & hybrid.
                </p>
                <p>
                  Jacob Kvist har 30 års erfaring indenfor autobranchen og har desuden gennemført uddannelsen på FTZ Akademi i fremtidens biler el og hybrid.
                </p>
              </div>

              <div className="pt-2">
                <Link
                  to="/frejlev-auto-dit-lokale-autovaerksted"
                  className="inline-block border-2 border-gray-900 hover:bg-gray-900 hover:text-white text-gray-900 font-bold text-xs uppercase tracking-wider px-6 py-3 transition-colors"
                >
                  LÆS MERE OM OS
                </Link>
              </div>

              {/* Accreditations Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-6">
                <div className="border border-gray-200 bg-gray-50 p-5 space-y-2">
                  <h4 className="font-bold text-gray-950 text-sm">Medlem af dansk bilbranche råd</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Vi er medlem af dansk bilbranche råd. Værkstedet er uafhængig af bilmærker og kan servicere og reparere mange mærker og modeller.
                  </p>
                  <a
                    href="https://dbr.dk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block border border-gray-400 hover:border-gray-900 text-gray-800 text-[11px] font-semibold px-3 py-1.5 uppercase mt-2 transition-colors"
                  >
                    LÆS MERE HER
                  </a>
                </div>

                <div className="border border-gray-200 bg-gray-50 p-5 space-y-2">
                  <h4 className="font-bold text-gray-950 text-sm">Et af Frie Danske Værksteder</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Værkstedet er et af de Frie Danske Værksteder og du bevarer garantien på bilen. Men hvad er Frie Danske Værksteder?
                  </p>
                  <a
                    href="https://frievaerksteder.dk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block border border-gray-400 hover:border-gray-900 text-gray-800 text-[11px] font-semibold px-3 py-1.5 uppercase mt-2 transition-colors"
                  >
                    LÆS MERE HER
                  </a>
                </div>
              </div>
            </div>

            {/* Right Photo: Jacob Kvist */}
            <div className="lg:col-span-5 flex justify-center">
              <div className="relative w-full max-w-md shadow-2xl overflow-hidden rounded-lg border border-gray-200">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/img-3974.jpeg"
                  alt="Jacob Kvist - Frejlev Auto"
                  className="w-full h-auto object-cover"
                />
                <div className="bg-gray-950 text-white p-4 text-center">
                  <p className="font-bold text-sm">Jacob Kvist</p>
                  <p className="text-xs text-gray-400">Ejer & Mekaniker ved Frejlev Auto</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Highlight Green Contact Bar */}
      <section className="bg-[#5cbe4f] text-white py-10 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-white/20">
          <div className="pt-4 md:pt-0 space-y-1">
            <i className="fa-solid fa-phone text-2xl mb-2 inline-block"></i>
            <p className="text-xs uppercase tracking-wider opacity-90">Ring til os på tlf:</p>
            <p className="text-xl sm:text-2xl font-black">
              <a href="tel:+4530345096" className="hover:underline">30 34 50 96</a>
            </p>
          </div>

          <div className="pt-4 md:pt-0 space-y-1">
            <i className="fa-solid fa-location-dot text-2xl mb-2 inline-block"></i>
            <p className="text-xs uppercase tracking-wider opacity-90">Find os her:</p>
            <p className="text-base sm:text-lg font-bold">
              <a 
                href="https://maps.app.goo.gl/NYxKMqLFdfv6L8976" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:underline"
              >
                Svenstrupvej 39, 9200 Aalborg SV
              </a>
            </p>
          </div>

          <div className="pt-4 md:pt-0 space-y-1">
            <i className="fa-solid fa-envelope text-2xl mb-2 inline-block"></i>
            <p className="text-xs uppercase tracking-wider opacity-90">Skriv til os på:</p>
            <p className="text-base sm:text-lg font-bold">
              <a href="mailto:frejlevauto@gmail.com" className="hover:underline">frejlevauto@gmail.com</a>
            </p>
          </div>
        </div>
      </section>

      {/* 6. Photo Gallery Mosaic */}
      <section className="bg-gray-100 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-gray-900">
              Billeder fra værkstedet
            </h2>
            <p className="text-gray-500 text-xs sm:text-sm mt-1">
              Et kig ind i vores moderne faciliteter og det daglige arbejde
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {mosaicImages.map((src, idx) => (
              <div 
                key={idx} 
                className="aspect-square overflow-hidden bg-gray-200 border border-gray-300 shadow-sm group"
              >
                <img
                  src={src}
                  alt={`Frejlev Auto Galleri ${idx + 1}`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <div className="text-center mt-6">
            <Link
              to="/galleri"
              className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-gray-900 hover:text-[#5cbe4f] transition-colors"
            >
              <span>Se hele galleriet</span>
              <i className="fa-solid fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* 7. Contact Section (Bright & Welcoming) */}
      <section className="bg-white py-16 sm:py-24 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <h2 className="text-2xl sm:text-4xl font-black uppercase tracking-tight text-gray-950">
              KONTAKT FREJLEV AUTO OG LAD OS HJÆLPE DIG GODT PÅ VEJ IGEN!
            </h2>
            <div className="w-16 h-1 bg-[#5cbe4f] mx-auto mt-4 mb-4"></div>
            <p className="text-gray-600 text-sm sm:text-base">
              Har du spørgsmål eller ønsker du at bestille en tid til din bil? Ring eller udfyld formularen nedenfor.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Form */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

            {/* Info & Map */}
            <div className="lg:col-span-5 space-y-6">
              <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 sm:p-8 space-y-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 uppercase tracking-wide">
                  Besøg vores værksted
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Du finder os på Svenstrupvej 39 i Aalborg SV. Du er altid velkommen til at køre forbi til en uforpligtende snak om din bil.
                </p>

                <div className="space-y-4 text-sm text-gray-700">
                  <div className="flex items-start gap-3">
                    <i className="fa-solid fa-location-dot text-[#5cbe4f] mt-1 text-base"></i>
                    <div>
                      <p className="font-bold text-gray-900">Adresse</p>
                      <p>Svenstrupvej 39, 9200 Aalborg SV</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <i className="fa-solid fa-phone text-[#5cbe4f] mt-1 text-base"></i>
                    <div>
                      <p className="font-bold text-gray-900">Telefon</p>
                      <a href="tel:+4530345096" className="hover:text-[#5cbe4f] font-semibold">30 34 50 96</a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <i className="fa-solid fa-envelope text-[#5cbe4f] mt-1 text-base"></i>
                    <div>
                      <p className="font-bold text-gray-900">E-mail</p>
                      <a href="mailto:frejlevauto@gmail.com" className="hover:text-[#5cbe4f]">frejlevauto@gmail.com</a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="w-full h-64 sm:h-72 rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
                <iframe
                  title="Frejlev Auto Beliggenhed"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115636.13318756905!2d9.716999084128203!3d57.01253171820594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4649337e2403e3c1%3A0xa58a3cb996e00a4a!2sFrejlev%20Auto!5e0!3m2!1sen!2sdk!4v1782305122760!5m2!1sen!2sdk"
                  className="w-full h-full border-0"
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
